import PropTypes from 'prop-types';


const Button = ({ children, onClick, type = 'button', variant = 'primary', disabled = false}) => {
    return (

        <button
            className = "btn siguiente order-1"
            type={type}
            onClick={onClick}
            disabled={disabled}
         >
         {children}
        </button>
    );
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['button','submit','']),
    variant: PropTypes.oneOf(['primary','secondary','danger']),
    disabled: PropTypes.bool,
};

export default Button;